import SharedEwaybillAccountType from "@/enum/SharedEwaybillAccountType";

const SharedEwaybillAccountTypeNameMap = {
  [SharedEwaybillAccountType.JD]: "京东无界电子面单",

  [SharedEwaybillAccountType.JDL]: "京东物流云",

  [SharedEwaybillAccountType.JINRITEMAI]: "抖音电子面单",

  [SharedEwaybillAccountType.OFFICIAL]: "快递官方电子面单",

  [SharedEwaybillAccountType.PDD]: "拼多多店铺电子面单",

  [SharedEwaybillAccountType.PDD_AUTH]: "拼多多站外电子面单",

  [SharedEwaybillAccountType.TAOBAO_CAINIAO_AUTH]: "淘宝菜鸟电子面单授权",

  [SharedEwaybillAccountType.JINRITEMAI_AUTH]: "抖音站外电子面单",

  [SharedEwaybillAccountType.KWAISHOP]: "快手电子面单",

  [SharedEwaybillAccountType.XIAOHONGSHU]: "小红书电子面单",

  [SharedEwaybillAccountType.CHANNEL_SHOP]: "视频号电子面单",
};

export default SharedEwaybillAccountTypeNameMap;
